module.exports = __webpack_public_path__ + "img/Modanisa.92023e8e.png";